import React from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";

import { loadCustomer } from "@customer-app/state/actionCreators/auth";
import { loadTheme, setTheme } from "@customer-app/state/actionCreators/theme";
import { store } from "@customer-app/state/store";

import AuthenticationFlow from "./Flows";

import "react-toastify/dist/ReactToastify.css";

function initialize({ orgShopifyDomain }: { orgShopifyDomain: any }) {
  const rootElement = document.getElementById("smartrr_passwordless_login");

  if (rootElement) {
    setTimeout(() => {
      store.dispatch(loadCustomer());
      const root = createRoot(rootElement);
      root.render(
        <ReduxProvider store={store}>
          <AuthenticationFlow shopifyDomain={orgShopifyDomain} />
        </ReduxProvider>
      );
    }, 0);
  }
}

function initialSetup() {
  const windowAny = window as any;

  if (!windowAny.smartrr) {
    windowAny.smartrr = {};
  }

  if (windowAny.smartrr.theme) {
    store.dispatch(setTheme(windowAny.smartrr.theme));
  } else {
    windowAny.smartrr.theme = null;
    store.dispatch(loadTheme());
  }

  windowAny.smartrr.otp = {
    initialize,
  };
}

initialSetup();
